const fieldTypeIcon = type => {
  const typeIcon = {
    checkbox: "mdi-checkbox-marked-outline",
    currency: "mdi-cash",
    cpf_cnpj: "mdi-account-card-details",
    date: "mdi-calendar-blank",
    email: "mdi-email-outline",
    image: "mdi-image-area",
    select: "mdi-format-list-checks",
    number: "mdi-numeric",
    radio: "mdi-radiobox-marked",
    text: "mdi-textbox",
    textarea: "mdi-textbox"
  };
  return typeIcon[type];
};

export default fieldTypeIcon;



// WEBPACK FOOTER //
// ./src/mixins/field-type-icon.js